import { EntityType } from '@frontend/common';
import { EquipmentGroupClient } from '@frontend/group/api';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useEquipmentGroup:request': CustomEvent<string>;
    }
}

const REQUEST_EQUIPMENT_GROUP_EVENT = 'useEquipmentGroup:request';
const STORAGE_KEY = 'EQW_GRP_REQ';

export function equipmentGroupRequest(groupId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_EQUIPMENT_GROUP_EVENT, { detail: groupId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function EquipmentGroupResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_EQUIPMENT_GROUP_EVENT, EntityType.EQUIPMENT_GROUP, (ids) => EquipmentGroupClient.resolveEquipmentGroups(ids), props.dispatch);
    return <></>;
}
